import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import TopBar from './TopBar';
import BottomNav from './BottomNav';
import { useAuth } from '../../context/AuthContext';
import AlertBanner from '../UI/AlertBanner';
import { useAlertBanner } from '../../context/AlertBannerContext';
import AdvertisementCarousel from '../Advertising/AdvertisementCarousel';

// Auto logout after inactivity
const SESSION_TIMEOUT = 5 * 60 * 1000; // 5 minutes

const Layout = () => {
  const { currentUser, logout } = useAuth();
  const { alert } = useAlertBanner();
  const location = useLocation();
  const navigate = useNavigate();
  const [lastActivity, setLastActivity] = useState<number>(Date.now());
  
  // Update last activity time on user interaction
  useEffect(() => {
    const updateActivity = () => {
      setLastActivity(Date.now());
    };
    
    // Add event listeners for user activity
    window.addEventListener('mousemove', updateActivity);
    window.addEventListener('keydown', updateActivity);
    window.addEventListener('click', updateActivity);
    window.addEventListener('scroll', updateActivity);
    
    return () => {
      window.removeEventListener('mousemove', updateActivity);
      window.removeEventListener('keydown', updateActivity);
      window.removeEventListener('click', updateActivity);
      window.removeEventListener('scroll', updateActivity);
    };
  }, []);
  
  // Check for inactivity and logout if needed
  useEffect(() => {
    if (!currentUser) return;
    
    const interval = setInterval(() => {
      const now = Date.now();
      if (now - lastActivity > SESSION_TIMEOUT) {
        logout();
      }
    }, 60000); // Check every minute
    
    return () => clearInterval(interval);
  }, [currentUser, lastActivity, logout]);
  
  // Check if we're on an auth page
  const isAuthPage = ['/login', '/register', '/forgot-password'].includes(location.pathname);
  const isHomePage = location.pathname === '/';

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <TopBar />
      
      {alert && <AlertBanner message={alert.message} />}
      
      {/* Advertisement Carousel - Only show on non-auth pages */}
      {!isAuthPage && (
        <div className="relative z-10">
          <AdvertisementCarousel />
        </div>
      )}
      
      <main className="flex-grow pb-16">
        <Outlet />
      </main>
      
      {currentUser && !isAuthPage && <BottomNav />}
    </div>
  );
};

export default Layout;